import MappedDataColumn, { cellType, mappedDataColumnConfiguration } from './MappedDataColumn.component';

export { cellType, MappedDataColumn };
export default mappedDataColumnConfiguration;
